import AstroStaticPage from "@/common/components/AstroStaticPage";
import React from "react";
import { Data } from "./data";

const Aarti = () => {
  return <AstroStaticPage data={Data} />;
};

export default Aarti;
